import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Collapse } from 'reactstrap';
import _ from 'lodash';


class FlyoutExpandableDetailsItem extends Component {
  constructor(props) {
    super(props);
    const { initiallyOpen } = this.props;

    this.state = {
      open: initiallyOpen,
    };
  }

  componentDidUpdate(prevProps) {
    const { open } = this.props;

    if (_.isNil(open) && open !== prevProps.open) {
      // trigger a toggle
      this.setOpen(open);
    }
  }

  setOpen(open) {
    this.setState({ open });
  }

  toggle() {
    this.setOpen(!this.state.open);
  }

  render() {
    const {
      text,
      children,
      initiallyOpen,
      classes,
    } = this.props;
    const { open = initiallyOpen } = this.state;

    return (
      <div className={`flyout-expandable-details ${classes}`}>
        <div role='button' tabIndex={0} onClick={() => this.toggle()} className='flyout-expandable-details-text'>{text} <i className={open ? 'fas fa-angle-down' : 'fas fa-angle-right'} /></div>
        <div className='flyout-expandable-details-contents'>
          <Collapse isOpen={open}>
            { children }
          </Collapse>
        </div>
      </div>);
  }
}

FlyoutExpandableDetailsItem.propTypes = {
  initiallyOpen: PropTypes.bool,
  open: PropTypes.bool,
  text: PropTypes.node.isRequired,
  classes: PropTypes.string,
  children: PropTypes.node,
};

FlyoutExpandableDetailsItem.defaultProps = {
  initiallyOpen: false,
  open: null,
  classes: '',
  children: [],
};

export default FlyoutExpandableDetailsItem;



// WEBPACK FOOTER //
// ./src/views/Components/FlyoutExpandableDetailsItem.js